import { render } from "./CmsDashboard.vue?vue&type=template&id=0577eaff&scoped=true"
import script from "./CmsDashboard.vue?vue&type=script&lang=js"
export * from "./CmsDashboard.vue?vue&type=script&lang=js"

import "./CmsDashboard.vue?vue&type=style&index=0&id=0577eaff&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0577eaff"]])

export default __exports__